import { render, staticRenderFns } from "./dashboardTab.vue?vue&type=template&id=5386d381&lang=pug"
import script from "./dashboardTab.vue?vue&type=script&lang=js"
export * from "./dashboardTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports